(function () {
  function readJsonScript(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return {};
    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function setButtonLoading(button, isLoading, label) {
    if (!button) return;
    if (!button.dataset.defaultLabel) {
      button.dataset.defaultLabel = button.textContent.trim();
    }
    button.disabled = !!isLoading;
    button.textContent = isLoading ? label : button.dataset.defaultLabel;
  }

  function showNotice(node, message, type) {
    if (!node) return;
    node.textContent = message || '';
    node.classList.toggle('is-visible', Boolean(message));
    node.classList.toggle('is-error', type === 'error');
    node.classList.toggle('is-success', type === 'success');
  }

  function safeText(value, fallback) {
    if (value === null || value === undefined || value === '') return fallback || '';
    return String(value);
  }

  function formatDate(value, locale) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    try {
      return new Intl.DateTimeFormat(locale || document.documentElement.lang || 'es', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).format(date);
    } catch (error) {
      return date.toLocaleString();
    }
  }

  function clearChildren(node) {
    while (node && node.firstChild) {
      node.removeChild(node.firstChild);
    }
  }

  function createPill(text) {
    var pill = document.createElement('span');
    pill.className = 'labosch-seur-tracking__pill';
    pill.textContent = text;
    return pill;
  }


  function toTitleCase(value) {
    var locale = document.documentElement.lang || 'es';
    return safeText(value, '').toLocaleLowerCase(locale).replace(/(^|\s|[-'])\S/g, function (letter) {
      return letter.toLocaleUpperCase(locale);
    });
  }

  function maskRecipientName(value) {
    var text = safeText(value, '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    var parts = text.split(' ').filter(Boolean);
    if (!parts.length) return '';
    var first = toTitleCase(parts[0]);
    var initial = '';
    if (parts.length > 1 && parts[1]) {
      initial = ' ' + toTitleCase(parts[1]).charAt(0) + '.';
    }
    return first + initial;
  }


  function normalizeKey(value) {
    return safeText(value, '').toLowerCase().replace(/[^a-z0-9áéíóúüñç]/gi, '');
  }

  function walkObject(value, callback, path) {
    if (!value || typeof value !== 'object') return '';
    path = path || [];

    if (Array.isArray(value)) {
      for (var i = 0; i < value.length; i += 1) {
        var arrayResult = walkObject(value[i], callback, path.concat(String(i)));
        if (arrayResult) return arrayResult;
      }
      return '';
    }

    var keys = Object.keys(value);
    for (var k = 0; k < keys.length; k += 1) {
      var key = keys[k];
      var result = callback(key, value[key], value, path);
      if (result) return result;

      if (value[key] && typeof value[key] === 'object') {
        var childResult = walkObject(value[key], callback, path.concat(key));
        if (childResult) return childResult;
      }
    }
    return '';
  }

  function findDeepString(source, exactKeys) {
    var wanted = (exactKeys || []).map(normalizeKey);
    return walkObject(source, function (key, value) {
      if (value === null || value === undefined || typeof value === 'object') return '';
      if (wanted.indexOf(normalizeKey(key)) === -1) return '';
      var text = safeText(value, '').replace(/\s+/g, ' ').trim();
      return text && text.length <= 120 ? text : '';
    });
  }

  function findContextualName(source) {
    var contextWords = /(recipient|receiver|consignee|addressee|destination|destinatario|destino|entrega|cliente)/i;
    return walkObject(source, function (key, value, parent, path) {
      if (value === null || value === undefined || typeof value === 'object') return '';
      var normalized = normalizeKey(key);
      if (['name', 'fullname', 'customername', 'contactname', 'nombre', 'nombredestinatario'].indexOf(normalized) === -1) return '';
      var context = path.concat(key).join(' ');
      if (!contextWords.test(context)) return '';
      var text = safeText(value, '').replace(/\s+/g, ' ').trim();
      if (!text || text.indexOf('@') !== -1 || /\d{6,}/.test(text)) return '';
      return text.length <= 90 ? text : '';
    });
  }

  function findRecipientName(payload) {
    var shipment = payload.shipment || {};
    return shipment.recipientName || shipment.receiverName || shipment.consigneeName ||
      findDeepString(payload.raw || payload, [
        'recipientName', 'receiverName', 'consigneeName', 'addresseeName', 'destinationName',
        'nombreDestinatario', 'destinatarioNombre', 'nombre', 'contactName', 'customerName'
      ]) || findContextualName(payload.raw || payload);
  }

  function findPackageCount(payload) {
    var shipment = payload.shipment || {};
    var direct = shipment.packagesCount || shipment.packageCount || shipment.packsCount || '';
    if (direct) return String(direct);
    var raw = payload.raw || payload;
    if (raw && typeof raw === 'object') {
      var packArrayCount = walkObject(raw, function (key, value) {
        if (!Array.isArray(value)) return '';
        var normalized = normalizeKey(key);
        if (['packs', 'parcels', 'packages', 'bultos'].indexOf(normalized) !== -1 && value.length) {
          return String(value.length);
        }
        return '';
      });
      if (packArrayCount) return packArrayCount;
    }
    return '';
  }

  function formatPackageCount(count) {
    var numberValue = Number(count);
    if (!Number.isFinite(numberValue) || numberValue <= 1) return '';
    return String(numberValue);
  }

  function getReferenceValue(payload) {
    var shipment = payload.shipment || {};
    return safeText(shipment.ref || shipment.reference || shipment.customerReference || shipment.clientReference || '', '');
  }

  function createMetaDetail(label, value, modifier) {
    var item = document.createElement('div');
    item.className = 'labosch-seur-tracking__detail' + (modifier ? ' ' + modifier : '');

    var labelNode = document.createElement('span');
    labelNode.className = 'labosch-seur-tracking__detail-label';
    labelNode.textContent = label || '';

    var valueNode = document.createElement('strong');
    valueNode.className = 'labosch-seur-tracking__detail-value';
    valueNode.textContent = value || '';

    item.appendChild(labelNode);
    item.appendChild(valueNode);
    return item;
  }

  function prettifyStatus(value) {
    var text = safeText(value, '');
    if (!text) return '';
    var letters = text.replace(/[^A-Za-zÀ-ÖØ-öø-ÿ]/g, '');
    if (letters && letters === letters.toUpperCase()) {
      var lower = text.toLocaleLowerCase(document.documentElement.lang || 'es');
      return lower.charAt(0).toLocaleUpperCase(document.documentElement.lang || 'es') + lower.slice(1);
    }
    return text;
  }

  function normalizeText(value) {
    var text = safeText(value, '').toLowerCase();
    try {
      return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    } catch (error) {
      return text;
    }
  }

  function inferProgressStage(payload) {
    var current = payload.currentStatus || {};
    var events = Array.isArray(payload.events) ? payload.events : [];
    var text = [current.description, current.code]
      .concat(events.map(function (event) { return [event.description, event.code].filter(Boolean).join(' '); }))
      .join(' ');
    var normalized = normalizeText(text);

    if (/entreg|delivery completed|delivered|finalizad/.test(normalized)) return 3;
    if (/reparto|repartidor|ruta|transito|transit|en camino|delegacion|destino|clasific|incidencia|ausente|pendiente|out for delivery/.test(normalized)) return 2;
    if (/recibido en origen|origen|recibido|recogid|admitid|expedid|salida|shipped|collected|picked|pickup|preparad/.test(normalized)) return 1;
    return 0;
  }


  function getStatusMessage(payload, i18n) {
    var current = (payload && payload.currentStatus) || {};
    var events = Array.isArray(payload && payload.events) ? payload.events : [];
    var text = [current.description, current.code]
      .concat(events.map(function (event) { return [event.description, event.code].filter(Boolean).join(' '); }))
      .join(' ');
    var normalized = normalizeText(text);

    if (/entregado en punto|punto seur|pick\s?up|pickup/.test(normalized)) {
      return i18n.messagePickupPoint || i18n.messageDelivered || '';
    }
    if (/entreg|delivery completed|delivered|finalizad/.test(normalized)) {
      return i18n.messageDelivered || '';
    }
    if (/incidencia|ausente|imposible|failed|problem|pendiente/.test(normalized)) {
      return i18n.messageIssue || '';
    }
    if (/reparto|repartidor|ruta|transito|transit|en camino|out for delivery/.test(normalized)) {
      return i18n.messageTransit || '';
    }
    if (/recibido en origen|origen|recibido|recogid|admitid|expedid|salida|shipped|collected|picked|preparad/.test(normalized)) {
      return i18n.messagePrepared || '';
    }
    if (/registr|created|label/.test(normalized)) {
      return i18n.messageRegistered || '';
    }
    return i18n.messageDefault || '';
  }

  function renderProgress(root, payload) {
    var progress = root.querySelector('[data-lb-seur-tracking-progress]');
    if (!progress) return;

    var list = progress.querySelector('.labosch-seur-tracking__progress-list');
    var steps = progress.querySelectorAll('[data-lb-seur-tracking-stage]');
    var stage = inferProgressStage(payload || {});
    var percent = steps.length > 1 ? (stage / (steps.length - 1)) * 100 : 0;

    if (list) list.style.setProperty('--lb-seur-progress', percent + '%');

    steps.forEach(function (step) {
      var index = Number(step.getAttribute('data-lb-seur-tracking-stage')) || 0;
      var isComplete = index < stage;
      var isActive = index === stage;

      step.classList.toggle('is-complete', isComplete);
      step.classList.toggle('is-active', isActive);

      if (isActive) {
        step.setAttribute('aria-current', 'step');
      } else {
        step.removeAttribute('aria-current');
      }
    });
  }

  function renderResult(root, payload, i18n) {
    var result = root.querySelector('[data-lb-seur-tracking-result]');
    var statusTitle = root.querySelector('[data-lb-seur-tracking-status-title]');
    var statusNote = root.querySelector('[data-lb-seur-tracking-status-note]');
    var meta = root.querySelector('[data-lb-seur-tracking-meta]');
    var timeline = root.querySelector('[data-lb-seur-tracking-timeline]');
    var raw = root.querySelector('[data-lb-seur-tracking-raw]');
    var resultLayout = root.querySelector('.labosch-seur-tracking__result-layout');
    var timelineCard = root.querySelector('.labosch-seur-tracking__timeline-card');

    if (!result || !statusTitle || !timeline) return;

    var current = payload.currentStatus || {};
    var events = Array.isArray(payload.events) ? payload.events : [];
    var shipment = payload.shipment || {};

    statusTitle.textContent = prettifyStatus(current.description) || i18n.statusUnknown || '';
    if (statusNote) statusNote.textContent = getStatusMessage(payload, i18n);

    clearChildren(meta);
    var recipient = maskRecipientName(findRecipientName(payload));
    var destination = [shipment.cityName, shipment.postalCode].filter(Boolean).join(' · ');
    var packageCount = formatPackageCount(findPackageCount(payload));
    var referenceValue = getReferenceValue(payload);

    if (recipient) meta.appendChild(createMetaDetail(i18n.recipientLabel || 'Envío para', recipient, 'is-recipient'));
    if (destination) meta.appendChild(createMetaDetail(i18n.destinationLabel || 'Destino', destination, 'is-destination'));
    if (current.date) meta.appendChild(createMetaDetail(i18n.updatedLabel || 'Actualizado', formatDate(current.date, payload.locale), 'is-updated'));
    if (shipment.ecb) meta.appendChild(createMetaDetail(i18n.ecbLabel || 'Bulto SEUR', shipment.ecb, 'is-ecb'));
    if (packageCount) meta.appendChild(createMetaDetail(i18n.packagesLabel || 'Bultos', packageCount, 'is-packages'));
    if (referenceValue) meta.appendChild(createMetaDetail(i18n.referenceLabel || 'Referencia', referenceValue, 'is-reference'));
    meta.classList.toggle('has-recipient', Boolean(recipient));

    clearChildren(timeline);
    if (events.length === 0 && current.description) {
      events = [current];
    }

    var showTimeline = events.length > 1;
    if (timelineCard) {
      timelineCard.hidden = !showTimeline;
    }
    if (resultLayout) {
      resultLayout.classList.toggle('is-single', !showTimeline);
    }

    events.forEach(function (event) {
      var item = document.createElement('li');
      item.className = 'labosch-seur-tracking__event';

      var dot = document.createElement('span');
      dot.className = 'labosch-seur-tracking__dot';
      dot.setAttribute('aria-hidden', 'true');

      var content = document.createElement('div');
      var title = document.createElement('p');
      title.className = 'labosch-seur-tracking__event-title';
      title.textContent = prettifyStatus(event.description) || i18n.statusUnknown || '';
      content.appendChild(title);

      if (event.date) {
        var date = document.createElement('span');
        date.className = 'labosch-seur-tracking__event-date';
        date.textContent = formatDate(event.date, payload.locale);
        content.appendChild(date);
      }

      item.appendChild(dot);
      item.appendChild(content);
      timeline.appendChild(item);
    });

    renderProgress(root, payload);

    if (raw) {
      raw.textContent = JSON.stringify(payload.raw || payload, null, 2);
      raw.classList.remove('is-visible');
    }

    result.classList.add('is-visible');
  }

  function initTracking(root) {
    var form = root.querySelector('[data-lb-seur-tracking-form]');
    if (!form) return;

    var i18n = readJsonScript(root, '[data-lb-seur-tracking-i18n]');
    var endpoint = form.getAttribute('data-endpoint') || '';
    var notice = root.querySelector('[data-lb-seur-tracking-notice]');
    var result = root.querySelector('[data-lb-seur-tracking-result]');
    var support = root.querySelector('[data-lb-seur-tracking-support]');
    var rawToggle = root.querySelector('[data-lb-seur-tracking-raw-toggle]');
    var raw = root.querySelector('[data-lb-seur-tracking-raw]');

    if (!endpoint) {
      showNotice(notice, i18n.notConfigured || '', 'error');
    }

    if (!rawToggle) {
      rawToggle = root.querySelector('.labosch-seur-tracking__raw-toggle');
    }

    if (rawToggle && raw) {
      rawToggle.addEventListener('click', function (event) {
        var trigger = event.target && event.target.closest ? event.target.closest('button, a') : null;
        var isVisible = raw.classList.toggle('is-visible');
        if (trigger) {
          trigger.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
        }
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var submit = form.querySelector('[type="submit"]');
      var refInput = form.querySelector('[name="ref"]');
      var ref = refInput ? refInput.value.trim() : '';

      if (!endpoint) {
        showNotice(notice, i18n.notConfigured || '', 'error');
        return;
      }

      if (!ref) {
        showNotice(notice, i18n.requiredFields || '', 'error');
        return;
      }

      showNotice(notice, '', '');
      if (result) result.classList.remove('is-visible');
      if (support) support.classList.remove('is-visible');
      setButtonLoading(submit, true, i18n.searching || '');

      fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          ref: ref,
          locale: document.documentElement.lang || 'es'
        })
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (body) {
            if (!response.ok) {
              var message = i18n.genericError || '';
              if (response.status === 404) message = i18n.notFound || message;
              if (response.status === 400) message = i18n.requiredFields || message;
              if (response.status === 500 || response.status === 502 || response.status === 503) message = i18n.genericError || message;
              var error = new Error(message);
              error.payload = body;
              throw error;
            }
            return body;
          });
        })
        .then(function (payload) {
          if (!payload || payload.found === false) {
            showNotice(notice, i18n.notFound || '', 'error');
            if (support) support.classList.add('is-visible');
            return;
          }

          renderResult(root, payload, i18n);
          showNotice(notice, '', '');
        })
        .catch(function (error) {
          showNotice(notice, error.message || i18n.genericError || '', 'error');
          if (support) support.classList.add('is-visible');
        })
        .finally(function () {
          setButtonLoading(submit, false, i18n.search || '');
        });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-lb-seur-tracking-root]').forEach(initTracking);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
